<template>
  <div id="map">
    <GmapMap
      :center="{lat:44.37, lng: -100.33}"
      :zoom="3"
      style="width: 100%; height: 700px"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in c_markers"
        :position="m.position"
        :title="m.title"
        :label="m.label"
        :icon="m.icon"
        :clickable="true"
        @dblclick="m_mapClick(m.label)"
      />
    </GmapMap>
  </div>
</template>
<script>
import {fn_getMapPosition} from "@/utils/api.js"
import {kbdpAlert} from "@/utils/util.js";
export default {
  name: "KTMap",
  props: {
    allMarkers: Array,
	p_highlightMarker:String,
  },
  data() {
    return {
	d_markers:[],
	d_highlightedAddress:null,
    d_greenURL: "https://maps.google.com/mapfiles/kml/paddle/grn-circle.png",
    d_blueURL: "https://maps.google.com/mapfiles/kml/paddle/blu-circle.png",
	d_redURL: "https://maps.google.com/mapfiles/kml/paddle/red-circle.png",
	d_pinkURL:"https://maps.google.com/mapfiles/kml/paddle/pink-circle.png",
	d_arrowURL:"https://maps.google.com/mapfiles/arrow.png",
	d_orangeURL:"https://maps.gstatic.com/mapfiles/ridefinder-images/mm_20_orange.png"
	};				
  },
  mounted(){

	this.m_createMarkers();
	
	//highlight the address of first marker.
	//this.m_mapClick(this.d_markers[0].label);
	
	
	
  },
  computed: {
  c_markers(){

	return this.d_markers;
	}
  },
  methods: {
	m_dblClick(){},
    m_mapClick(label){
	console.log(this.d_highlightedAddress)
	console.log(label.text);
	if(label.text !== this.d_highlightedAddress){ 
		this.$emit('highlightAddress', label.text);
		this.m_highlightMarker(label.text);
		this.d_highlightedAddress=label.text;
		}
	},
    m_createMarkers() {
      if (this.allMarkers.length > 0) {

		var statusURL;
		var status;

		
        for (let i = 0; i < this.allMarkers.length; i++) {
          statusURL=null;

          if ( this.allMarkers[i].streetAddress &&
               this.allMarkers[i].city &&
               this.allMarkers[i].stateProvince

          ) {

				var addressObj={streetAddress:this.allMarkers[i].streetAddress, 
                                city:this.allMarkers[i].city,
								stateProvince:this.allMarkers[i].stateProvince
								};

			
		
            fn_getMapPosition(addressObj).then(resp=>{
				var mapPosition=resp;
				
				
			if(mapPosition){
			
			statusURL=null;
			
			if(this.allMarkers[i].statusName){
                status=this.allMarkers[i].statusName.toLowerCase();
				if(["submitted", "open"].includes(status)) statusURL=this.d_greenURL;
				if(status == 'secured') statusURL=this.d_blueURL;
				if(status == 'not awarded') statusURL=this.d_redURL;
				} else {statusURL=this.d_orangeURL;}
				
 
				
			var marker={
              position: mapPosition, 			  
              title: this.allMarkers[i].opportunityName,
              label: {
                text: this.allMarkers[i].opportunityNo,
                color: "red",
                fontWeight: "bold",
                fontSize: "12px",
              },
              icon: {
                url: statusURL,
                scaledSize: { width: 35, height: 35 },
                labelOrigin: { x: 16, y: -10 },
              },
            };
			this.d_markers.push(marker);
			}
          });
        }
      }
    } 
  },
  m_highlightMarker(opportunityNo){
		//use arrow marker for current Address.
		
		var arrowIcon= {url: this.d_arrowURL,scaledSize: { width: 35, height: 35 },labelOrigin: { x: 16, y: -10 }};
		var markerId=this.d_markers.findIndex(m => m.label['text'] == opportunityNo);
			
			
		if(markerId > -1){
			var mapTitle=this.d_markers[markerId].title;
			var mapPosition=this.d_markers[markerId].position;
			var currentMarkerId=this.d_markers.findIndex(m => m.key == '99999');
			
		if(currentMarkerId > -1){
			this.d_markers[currentMarkerId].title=mapTitle;
			this.d_markers[currentMarkerId].position=mapPosition;
		} else {
			var marker={
              position: mapPosition, 			  
              title: mapTitle,
				key:'99999',
              label: {
                text: ' ',
                color: "red",
                fontWeight: "bold",
                fontSize: "12px",
              },
              icon: arrowIcon
            };
				this.d_markers.push(marker);
			}
		} else { kbdpAlert.showOk("Address not on the Map");}
		
	}
},
watch:{

	allMarkers(nv,ov){
		
		//this.d_markers.length=0;
		//this.d_markers=[];
		this.d_markers.splice(0, this.d_markers.length);
		this.m_createMarkers();
		},
    p_highlightMarker(nv, ov){
			console.log('nv:'+nv);
            //use arrow marker for current Address.
			this.m_highlightMarker(nv);
		
   }
   }
};
</script>

<style></style>
